import { CLIENT_TYPE } from '@/configs/constants'

// Route names that legal clients are not allowed to access.
const LEGAL_RESTRICTED_ROUTES = ['bonuses', 'tariffs', 'tariffs-constructor', 'tv', 'tv-service']

// Returns true when the given client profile is allowed to open the route.
export const hasRouteAccess = (routeName, clientProfile) => {
  if (clientProfile?.type === CLIENT_TYPE.LEGAL && LEGAL_RESTRICTED_ROUTES.includes(routeName)) {
    return false
  }
  return true
}
